import { useContext } from 'react';
import DataContext from '../DataContext/DataContext';
import { get } from 'lodash-es';

const useLabels = (...ids) => {
  const { language, labels } = useContext(DataContext);

  return ids.map(id => {
    const textConfig = labels.find(label => label.name === id);
    const text = get(textConfig, `info.${language}.text`);
    if (!text) {
      console.warn(`Translation missing for ${id} in language ${language}`);
      return id;
    }
    return text;
  });
};

export default useLabels;
